import React, { useState, useEffect } from 'react'
import moment from 'moment'
import _ from 'lodash'
import { FormattedMessage } from 'react-intl'
import { message } from 'core/components/ui'
import Hydrator, { hydratorMethods, hydratorOrigins } from 'core/hydrator'
import RequesterTradeIn, { RequesterTradeInMethods } from '../requesters/RequesterTradeIn'

const getYears = maxYears => {
  const currentYear = new Date().getFullYear()

  const years = []

  let i = 0
  for (i; i <= maxYears; i += 1) {
    years.push(currentYear - i)
  }

  return years
}

const monthsList = [
  { id: '01', value: <FormattedMessage id="tradeIn-vehicle-homeTradeIn-card2-input-1-data-1" /> },
  { id: '02', value: <FormattedMessage id="tradeIn-vehicle-homeTradeIn-card2-input-1-data-2" /> },
  { id: '03', value: <FormattedMessage id="tradeIn-vehicle-homeTradeIn-card2-input-1-data-3" /> },
  { id: '04', value: <FormattedMessage id="tradeIn-vehicle-homeTradeIn-card2-input-1-data-4" /> },
  { id: '05', value: <FormattedMessage id="tradeIn-vehicle-homeTradeIn-card2-input-1-data-5" /> },
  { id: '06', value: <FormattedMessage id="tradeIn-vehicle-homeTradeIn-card2-input-1-data-6" /> },
  { id: '07', value: <FormattedMessage id="tradeIn-vehicle-homeTradeIn-card2-input-1-data-7" /> },
  { id: '08', value: <FormattedMessage id="tradeIn-vehicle-homeTradeIn-card2-input-1-data-8" /> },
  { id: '09', value: <FormattedMessage id="tradeIn-vehicle-homeTradeIn-card2-input-1-data-9" /> },
  {
    id: '10',
    value: <FormattedMessage id="tradeIn-vehicle-homeTradeIn-card2-input-1-data-10" />
  },
  {
    id: '11',
    value: <FormattedMessage id="tradeIn-vehicle-homeTradeIn-card2-input-1-data-11" />
  },
  {
    id: '12',
    value: <FormattedMessage id="tradeIn-vehicle-homeTradeIn-card2-input-1-data-12" />
  }
]

const useGetCars = props => {
  const { redirectMessage } = props

  const [cars, setCars] = useState({})
  const [error, setError] = useState(false)
  const [errorMessage, setErrorMessage] = useState(null)
  const [loading, setLoading] = useState(false)
  const [appliedFilters, setAppliedFilters] = useState({ changeModel: false })

  const [filters, setFilters] = useState({
    yearsList: getYears(props.maximumAgeTradeInCars),
    monthsList
  })

  const getCarsByNumberplate = params => {
    setError(false)
    setErrorMessage()
    setLoading(true)
    RequesterTradeIn.get(RequesterTradeInMethods.GET_CAR_FROM_NUMBER_PLATE, params, redirectMessage)
      .then(datas => {
        const { items } = datas
        const vehiclesList = items
          .filter(
            item =>
              !item.catalog ||
              moment(item.catalog).year() >= new Date().getFullYear() - props.maximumAgeTradeInCars
          )
          .map(item => {
            const itemExtended = {
              ...item,
              id: item.referentialCarId,
              putIntoService: item.putIntoService,
              catalog: item.catalog
            }

            return Hydrator.hydrate(
              hydratorMethods.HYDRATE_VEHICLE,
              itemExtended,
              hydratorOrigins.ORIGIN_DETAIL
            )
          })

        if (vehiclesList.length > 0) {
          setCars(vehiclesList)
        } else {
          setError(true)
        }
      })
      .catch(e => {
        if (e.includes('429')) setErrorMessage('error-429-title')
        setError(true)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  const onChangeDate = (type, value, deactivatedMakes) => {
    const { year, month } = appliedFilters
    let extenderFilters
    let selectedDate

    switch (type) {
      case 1:
        selectedDate = month && `${value}-${month}-01`
        extenderFilters = { ...appliedFilters, year: value, selectedDate }
        break
      case 2:
        selectedDate = year && `${year}-${value}-01`
        extenderFilters = { ...appliedFilters, month: value, selectedDate }
        break
      case 3:
        {
          const yearSplit = moment(value).year()
          const monthSplit = moment(value).format('MM')

          selectedDate = yearSplit && monthSplit && `${yearSplit}-${monthSplit}-01`
          extenderFilters = { ...appliedFilters, year: yearSplit, month: monthSplit, selectedDate }
        }
        break
      default:
        break
    }

    extenderFilters = {
      ...extenderFilters,
      energyId: null,
      trimId: null
    }
    setFilters({ ...filters, deactivatedMakes })
    setAppliedFilters(extenderFilters)
  }

  const onChangeMake = makeId => {
    const extendedfilter = {
      ...appliedFilters,
      makeId,
      modelId: null,
      energyId: null,
      trimId: null
    }
    setAppliedFilters(extendedfilter)
  }

  const onChangeModel = modelId => {
    const extendedfilter = {
      ...appliedFilters,
      modelId,
      energyId: null,
      trimId: null
    }
    setAppliedFilters(extendedfilter)
  }

  const onChangeEnergy = energyId => {
    const extendedfilter = {
      ...appliedFilters,
      energyId,
      trimId: null
    }
    setAppliedFilters(extendedfilter)
  }

  const onChangeTrim = trimId => {
    const extendedfilter = {
      ...appliedFilters,
      trimId
    }
    setAppliedFilters(extendedfilter)
  }

  const getCarsManually = () => {
    setError(false)
    setLoading(true)

    const { selectedDate, makeId, modelId, trimId, energyId } = appliedFilters
    const { makesList, modelsList, energiesList, trimsList } = filters

    const make = _.first(makesList.filter(filter => filter.id === makeId)).value

    const modelSelected = _.first(modelsList.filter(filter => filter.id === modelId))
    const modelName = modelSelected.value
    const { picture } = modelSelected

    const trim = _.first(trimsList.filter(filter => filter.id === trimId)).value

    const fileteredEnergiesList = _.first(energiesList.filter(filter => filter.id === energyId))

    const fuel = fileteredEnergiesList ? fileteredEnergiesList.value : null

    const params = {
      date: selectedDate,
      makeId,
      modelId,
      energyId: energyId && [energyId],
      trim
    }

    RequesterTradeIn.get(RequesterTradeInMethods.GET_VERSIONS, params, redirectMessage)
      .then(datas => {
        const { items } = datas

        const vehiclesList = items.map(item => {
          const itemExtended = {
            ...item,
            make,
            makeId,
            model: modelName,
            modelId,
            trim,
            trimId,
            fuel,
            fuelId: energyId,
            putIntoService: selectedDate,
            picture
          }

          return Hydrator.hydrate(
            hydratorMethods.HYDRATE_VEHICLE,
            itemExtended,
            hydratorOrigins.ORIGIN_DETAIL
          )
        })

        setCars(vehiclesList)
      })
      .catch(e => {
        message.error(e)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  useEffect(() => {
    const runIt = modelId => {
      const params = {
        date: appliedFilters.selectedDate,
        makeId: appliedFilters.makeId,
        modelId
      }

      setError(false)
      setLoading(true)
      RequesterTradeIn.get(RequesterTradeInMethods.GET_FINISHES_ENERGIES, params, redirectMessage)
        .then(datas => {
          const { trims, energies } = datas

          const trimsList = trims.map(trim => ({
            id: trim.id,
            value: trim.trim,
            inclVatPrice: trim.inclVatPrice
          }))

          const energiesList = energies.map(fuel => ({
            id: fuel.id,
            value: fuel.fuel
          }))

          const extendedFiltersList = {
            ...filters,
            trimsList,
            energiesList
          }
          setFilters(extendedFiltersList)
        })
        .catch(e => {
          message.error(e)
        })
        .finally(() => {
          setLoading(false)
        })
    }

    if (appliedFilters.modelId) runIt(appliedFilters.modelId)
  }, [appliedFilters.modelId])

  useEffect(() => {
    const runIt = makeId => {
      const params = {
        date: appliedFilters.selectedDate,
        makeId
      }

      setError(false)
      setLoading(true)
      RequesterTradeIn.get(RequesterTradeInMethods.GET_MODELS, params, redirectMessage)
        .then(datas => {
          const { items } = datas

          const extendedFiltersList = {
            ...filters,
            modelsList: items.map(model => ({
              id: model.id,
              value: model.model,
              picture: model.picture
            }))
          }

          if (!items.find(x => x.id === appliedFilters.modelId)) {
            setAppliedFilters({ ...appliedFilters, modelId: null })
          } else {
            setAppliedFilters({ ...appliedFilters, modelId: appliedFilters.modelId })
          }

          setFilters(extendedFiltersList)
        })
        .catch(e => {
          message.error(e)
        })
        .finally(() => {
          setLoading(false)
        })
    }

    if (appliedFilters.makeId) runIt(appliedFilters.makeId)
  }, [appliedFilters.makeId, appliedFilters.changeModel])

  useEffect(() => {
    const runIt = d => {
      const params = {
        date: d
      }
      setError(false)
      setLoading(true)
      RequesterTradeIn.get(RequesterTradeInMethods.GET_BRANDS, params, redirectMessage)
        .then(datas => {
          const { items } = datas

          const makesList = items
            .map(make => ({
              id: make.id,
              value: make.make
            }))
            .filter(make => !filters.deactivatedMakes.map(x => x.makeId).includes(make.id))

          const extendedFiltersList = {
            ...filters,
            makesList
          }

          if (appliedFilters.makeId && !makesList.find(x => x.id === appliedFilters.makeId)) {
            setAppliedFilters({ ...appliedFilters, makeId: null, modelId: null })
          } else {
            setAppliedFilters({ ...appliedFilters, changeModel: !appliedFilters.changeModel })
          }

          setFilters(extendedFiltersList)
        })
        .catch(e => {
          message.error(e)
        })
        .finally(() => {
          setLoading(false)
        })
    }

    if (appliedFilters.selectedDate) runIt(appliedFilters.selectedDate)
  }, [appliedFilters.selectedDate])

  useEffect(() => {
    const runIt = energyId => {
      const params = {
        date: appliedFilters.selectedDate,
        makeId: appliedFilters.makeId,
        modelId: appliedFilters.modelId,
        fuelId: energyId
      }

      setError(false)
      setLoading(true)
      RequesterTradeIn.get(RequesterTradeInMethods.GET_FINISHES, params, redirectMessage)
        .then(datas => {
          const { items } = datas

          const trimsList = items.map(trim => ({
            id: trim.id,
            value: trim.trim,
            inclVatPrice: trim.inclVatPrice
          }))

          const extendedFiltersList = {
            ...filters,
            trimsList
          }
          setFilters(extendedFiltersList)
        })
        .catch(e => {
          message.error(e)
        })
        .finally(() => {
          setLoading(false)
        })
    }

    if (appliedFilters.energyId) runIt(appliedFilters.energyId)
  }, [appliedFilters.energyId])

  return {
    appliedFilters,
    filters,
    onChangeDate,
    onChangeMake,
    onChangeModel,
    onChangeEnergy,
    onChangeTrim,
    getCarsManually,
    getCarsByNumberplate,
    error,
    errorMessage,
    loading,
    cars
  }
}

export default useGetCars
